// src/components/view-profile/ProfileTabs.js
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Package, Star } from "lucide-react";

const ProfileTabs = ({ 
  activeTab, 
  onTabChange, 
  productsCount, 
  wishlistCount,
  isOwner 
}) => {
  const { t, ready: i18nReady } = useTranslation(["profile", "common"]);

  // Safe translation with fallback
  const safeT = useMemo(() => {
    return (key, fallback = key) => {
      if (!i18nReady) return fallback;
      const result = t(key);
      return result === key ? fallback : result;
    };
  }, [t, i18nReady]);

  const tabs = [
    { 
      id: "products", 
      labelKey: "profile.tabs.products", 
      labelDefault: "Products",
      count: productsCount,
      icon: Package
    },
    ...(isOwner ? [{
      id: "wishlist", 
      labelKey: "profile.tabs.wishlist", 
      labelDefault: "Wishlist",
      count: wishlistCount,
      icon: Star
    }] : [])
  ];

  return (
    <div className="bg-white dark:bg-neutral-800 rounded-xl shadow-sm border border-gray-200 dark:border-neutral-700 overflow-hidden">
      <div className="flex">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 flex items-center justify-center py-3 sm:py-4 px-2.5 sm:px-4 text-sm sm:text-base font-medium transition-all duration-200 border-b-2 ${
              activeTab === tab.id
                ? "border-green-500 text-green-700 dark:text-green-300 bg-green-50 dark:bg-green-900/20"
                : "border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-neutral-700/50"
            }`}
          >
            <tab.icon size={16} className="mr-1.5 sm:mr-2 flex-shrink-0" />
            <span className="truncate">{safeT(tab.labelKey, tab.labelDefault)}</span>
            {tab.count > 0 && (
              <span className={`ml-1.5 sm:ml-2 px-2 py-0.5 sm:py-1 text-[11px] sm:text-xs rounded-full min-w-6 text-center ${
                activeTab === tab.id
                  ? "bg-green-100 dark:bg-green-800 text-green-700 dark:text-green-300"
                  : "bg-gray-100 dark:bg-neutral-700 text-gray-600 dark:text-gray-400"
              }`}>
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileTabs;